import BigNumber from "bignumber.js";
export function serializeCeloTransaction({ amount, family, fees = undefined, index = undefined, mode, recipient, }) {
    return {
        amount: amount.toString(),
        family,
        fees: fees ? fees.toString() : undefined,
        index,
        mode,
        recipient,
    };
}
export function deserializeCeloTransaction({ amount, family, fees = undefined, index = undefined, mode, recipient, }) {
    return {
        amount: new BigNumber(amount),
        family,
        fees: fees ? new BigNumber(fees) : undefined,
        index,
        mode,
        recipient,
    };
}
//# sourceMappingURL=serializer.js.map